import { render, staticRenderFns } from "./PrognoseSlider.vue?vue&type=template&id=af12bf0e"
import script from "./PrognoseSlider.js?vue&type=script&lang=js&external"
export * from "./PrognoseSlider.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports